module.exports = __webpack_public_path__ + "img/Hover_Serve_Unbanked.c5ec6851.png";